import moment from "moment"
import {createSelector} from "reselect"
import initialState from "./initialState2"
import {getCostProjection} from "../index"

// SELECTORS
export const getAssumptions = (state) => getCostProjection(state).assumptions

// 1
export const getAssumptionsPaginated = createSelector(
  getAssumptions,
  (assumptions) => {
    // Initialize empty array for results
    const results = []
    // Set max character length for line
    const lineLength = 60
    // Set max number of lines per page
    const maxLines = 40
    // Initialize variable for current line number
    let lineNumber = 0

    // Prepare function to increment line number
    const incrementLineNumber = (amount) => {
      // If line number reaches max
      if (lineNumber + amount >= maxLines) {
        // Reset line number
        lineNumber = 0
        // Determine is page break
        return true
      }
      // Increment line number by 1
      lineNumber += amount
      // Determine is not page break
      return false
    }

    assumptions.forEach((assumption) => {
      // Create function for preparing formatted dateTime string
      const prepareDateTime = (dateTime) => {
        if (dateTime) {
          return moment(dateTime).format("D MMM YYYY")
        }
      }
      // Convert text string into paginated data
      const lines = preparePaginatedSections(
        assumption.Text,
        lineLength,
        incrementLineNumber
      )
      // Create result object
      const result = {
        id: assumption.Id,
        createdBy: assumption.CreatedBy,
        createdOn: prepareDateTime(assumption.CreatedOn),
        updatedBy: assumption.UpdatedBy,
        updatedOn: prepareDateTime(assumption.UpdatedOn),
        lines,
      }
      // Push result to results array
      results.push(result)
    })
    // Return results
    return results
  }
)

const preparePaginatedSections = (string, lineLength, incrementLineNumber) => {
  // Split string based on new line
  const stringArray = string.split(/\r?\n/)
  // Initialize array for paginated items
  const paginatedItems = []
  // Iterate over parts of split string
  stringArray.forEach((text, textIndex) => {
    // Prepare paginated lines for each part of split string
    const paginatedLines = preparePaginatedLines(
      text,
      lineLength,
      incrementLineNumber,
      [],
      textIndex === 0
    )
    // Push paginated lines to paginated items array
    paginatedItems.push(...paginatedLines)
  })
  // Return paginated items
  return paginatedItems
}

const preparePaginatedLines = (
  string,
  lineLength,
  incrementLineNumber,
  lines,
  isFirstLine
) => {
  // Prepare new lines array which includes input lines
  const paginatedLines = [...lines]
  // Determine how much to increment line number
  // Increment by 3 for each new line to account for footer
  const incrementValue = isFirstLine ? 3 : 1
  // Increment the line number and determine if this line is page break
  const isPageBreak = incrementLineNumber(incrementValue)
  // If line is page break
  if (isPageBreak) {
    // Push page break to paginated lines array
    paginatedLines.push({isPageBreak: true, line: ""})
  }
  // If string length is shorter than line length
  if (string.length <= lineLength) {
    // Push string to previous lines
    paginatedLines.push({line: string})
    // Return all lines
    return paginatedLines
  }
  // Prepare slice index of string
  const sliceIndex = prepareSliceIndex(string, lineLength)
  // Use slice index to slice first part of string
  const firstPartial = string.slice(0, sliceIndex)
  // Push first part of string to all lines
  paginatedLines.push({line: firstPartial})
  // Use slice index to slice last part of string
  const lastPartial = string.slice(sliceIndex, string.length)
  // Recurse with last part of string
  return preparePaginatedLines(
    lastPartial,
    lineLength,
    incrementLineNumber,
    paginatedLines
  )
}

const prepareSliceIndex = (string, lineLength) => {
  // If last character of string is space, return index
  if (string[lineLength - 1] === " ") return lineLength
  // Check if next-to-last character of string is space
  return prepareSliceIndex(string, lineLength - 1)
}

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}
